import { Component, EventEmitter, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import { BulkMessage } from '@shared/factories';
import { SessionStorageService } from '@shared/services';

@Component({
  selector:      'bulk-messages',
  templateUrl: './bulk-messages.component.html',
  host: { class: 'am-flex-column am-flex-1 overflow' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BulkMessagesComponent implements OnDestroy {
  bulkType: string = 'list';
  message:  BulkMessage;

  @Output() close = new EventEmitter<void>();
  constructor(
    private sessionStorageService: SessionStorageService
  ) { }

  ngOnDestroy(): void {
    let useCase = this.sessionStorageService.searchSecondaryValueValue?.useCase;
    if (!useCase || useCase === 'bulkMessages' || useCase === 'bulkNew') this.sessionStorageService.changeSearchSecondaryValue(null);
  }

  editHandler(message: BulkMessage): void {
    this.message  = message;
    this.bulkType = 'new';
  }

  closeCreate(): void {
    this.message  = null;
    this.bulkType = 'list';
  }

}
